import {
  BOG_GAME_NAMES,
  BOG_LINE_GAME_TYPES,
  DefaultQueryParams,
  gameConfigStore,
  isMobile,
  parseQuery,
  resizeGame,
  userSettingsStore,
} from '@pascal/pascal-core';
import { registerApis } from '../../services/apiRegistration';
import { gameName } from '../../enums/gameConfigsAndUrls';
import { soundService } from '../../services/soundService';
import { liveConnection } from '../liveConnection';
import { gameLiveConnection } from '../../services/gameLiveConnection';
import { gameService } from '../../services/gameService';
import { brandedGameIds, brandedGameNameDependOnIds } from '../../enums/brandedPartners';

const maxHeight = 700;
const maxWidth = 1196;
const target = document.querySelector('.root');

export const init = () => {
  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGame(maxHeight, maxWidth, target);
    window.addEventListener('resize', () => resizeGame(maxHeight, maxWidth, target));
    document.documentElement.classList.add('is-web');
  }
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);

  if (brandedGameNameDependOnIds[gameId]) {
    document.documentElement.classList.add(`is-${brandedGameNameDependOnIds[gameId]}`);
  }

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName: `${gameName}_${gameId}`,
    soundService,
    gameService,
    liveConnection,
    gameLiveConnection,
  });
  registerApis();
  gameConfigStore.initGameConfigs(
    {
      sectionCount: 2,
      bogLineGameTypeData: {
        gameType: BOG_LINE_GAME_TYPES.ONLY_CRASH,
        isUsedPlatformIntegrationLogic: true,
        gameName: BOG_GAME_NAMES.FISHING,
        isUsedStakeUpdateLogic: false,
      },
      gameName: BOG_GAME_NAMES.FISHING,
      isUsedBogLineComponents: true,
      isAllSectionWithCashOutButton: true,
      isUsedInputValidationFunctionality: false,
      isUsedRoundStartAndFinishedLogicAfterCashOut: true,
    },
    {
      isGameHasPixi: true,
      isSilentModeFalse: +gameConfigStore.gameId === brandedGameIds['747'],
    }
  );
};
